import registry from './brands.json'

const { brands, defaultBrandId } = registry

const byHostname = Object.values(brands).reduce((index, brand) => {
  brand.hostnames.forEach((hostname) => {
    index[hostname] = brand
  })

  return index
}, {})

export const DEFAULT_BRAND_ID = defaultBrandId

export const listBrands = () => Object.values(brands)

export const getBrand = (brandId) => brands[brandId] || brands[defaultBrandId]

export const resolveBrand = (hostname) => byHostname[String(hostname || '').toLowerCase()] || brands[defaultBrandId]

export const isBrandHost = (hostname) => Boolean(byHostname[String(hostname || '').toLowerCase()])
